// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent-consumpDash {
  width: 95%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-column-gap: 5px;
  grid-row-gap: 5px;
}

@media (max-width: 768px) {
  .parent-consumpDash {
    display: block; /* acomoda los widgets uno abajo del otro */
  }

  .panel {
    margin-bottom: 15px;
  }
}

.div0-consumpDash {
  grid-area: 1 / 1 / 2 / 2;
}
.div1-consumpDash {
  grid-area: 1 / 2 / 2 / 3;
}
.div2a-consumpDash {
  grid-area: 1 / 3 / 2 / 5;
}
.div2b-consumpDash {
  grid-area: 1 / 5 / 2 / 7;
}
.divE3-consumpDash {
  grid-area: 2 / 4 / 3 / 5;
}
.divE0-consumpDash {
  grid-area: 1 / 5 / 2 / 6;
}
.divE6-consumpDash {
  grid-area: 1 / 6 / 2 / 7;
}
.divE2-consumpDash {
  grid-area: 2 / 3 / 3 / 4;
}
.divE1-consumpDash {
  grid-area: 2 / 2 / 3 / 3;
}
.divE4-consumpDash {
  grid-area: 2 / 5 / 3 / 6;
}
.divE5-consumpDash {
  grid-area: 2 / 6 / 3 / 7;
}
.divE0-consumpDash {
  grid-area: 2 / 1 / 3 / 2;
}
.divE8-consumpDash {
  grid-area: 4 / 7 / 3 / 5;
}
.divE6-consumpDash {
  grid-area: 3 / 3 / 4 / 1;
}
.divE7-consumpDash {
  grid-area: 3 / 5 / 4 / 3;
}
.div5-consumpDash {
  grid-area: 4 / 1 / 6 / 7;
}
.div6-consumpDash {
  grid-area: 6 / 1 / 8 / 7;
}
.div8-consumpDash {
  grid-area: 7 / 1 / 9 / 4;
}
.div9-consumpDash {
  grid-area: 8 / 1 / 10 / 7;
}
.div11-consumpDash {
  grid-area: 10 / 1 / 12 / 7;

}
.div12-consumpDash { grid-area: 12 / 1 / 14 / 4; }
.div13-consumpDash { grid-area: 12 / 4 / 14 / 7; }
.div14-consumpDash { grid-area: 14 / 1 / 16 / 7; }

.download-invoice {
  display: flex;
  justify-content: center;
}

.icon-download {
  cursor: pointer;
}

.sort-arrow {
  margin-left: 5px;
  cursor: pointer;
  color: rgb(116, 116, 116);
}

.titles {
  display: flex;
  justify-content: center;
}

.title {
  color: black;
}

.title-consumpCost{
  font-weight: 600;
}

.donuts-container {
  display: flex;
  justify-content: space-around; 
  align-items: flex-start;
}

.cont-donuts {
  flex: 1 1;
  margin: 10px;
  text-align: center;
  max-width: 250px;
  max-height: 260px;
}

/* menu reportes */
/* DashConsumption.css */
.dropdown-toggle-reports:hover{
  color: #4e6278;
  transition: color 0.3s ease;
}

.dropdown-menu-reports {
  padding: 10px;
  min-width: 230px;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0,0,0,0.1);
}

.dropdown-menu-reports li button {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #73879c;
  padding-bottom: 0px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.dropdown-menu-reports li:hover {
  background-color: #f2f2f2;
  border-radius: 6px;
}

.dropdown-menu-reports button {
  all: unset;
  width: 100%;
  text-align: left;
}

/* ChartTypeSelector */
.chart-type-selector {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  gap: 2px;
}

.chart-type-button {
  cursor: pointer;
  padding: 4px 8px;
  background: none;
  color: #4e6278;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.chart-type-button:hover {
  background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/DashConsumption/DashConsumption.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,cAAc,EAAE,2CAA2C;EAC7D;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;;AAE5B;AACA,qBAAqB,0BAA0B,EAAE;AACjD,qBAAqB,0BAA0B,EAAE;AACjD,qBAAqB,0BAA0B,EAAE;;AAEjD;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB,wBAAwB;AACxB;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".parent-consumpDash {\n  width: 95%;\n  margin: auto;\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n}\n\n@media (max-width: 768px) {\n  .parent-consumpDash {\n    display: block; /* acomoda los widgets uno abajo del otro */\n  }\n\n  .panel {\n    margin-bottom: 15px;\n  }\n}\n\n.div0-consumpDash {\n  grid-area: 1 / 1 / 2 / 2;\n}\n.div1-consumpDash {\n  grid-area: 1 / 2 / 2 / 3;\n}\n.div2a-consumpDash {\n  grid-area: 1 / 3 / 2 / 5;\n}\n.div2b-consumpDash {\n  grid-area: 1 / 5 / 2 / 7;\n}\n.divE3-consumpDash {\n  grid-area: 2 / 4 / 3 / 5;\n}\n.divE0-consumpDash {\n  grid-area: 1 / 5 / 2 / 6;\n}\n.divE6-consumpDash {\n  grid-area: 1 / 6 / 2 / 7;\n}\n.divE2-consumpDash {\n  grid-area: 2 / 3 / 3 / 4;\n}\n.divE1-consumpDash {\n  grid-area: 2 / 2 / 3 / 3;\n}\n.divE4-consumpDash {\n  grid-area: 2 / 5 / 3 / 6;\n}\n.divE5-consumpDash {\n  grid-area: 2 / 6 / 3 / 7;\n}\n.divE0-consumpDash {\n  grid-area: 2 / 1 / 3 / 2;\n}\n.divE8-consumpDash {\n  grid-area: 4 / 7 / 3 / 5;\n}\n.divE6-consumpDash {\n  grid-area: 3 / 3 / 4 / 1;\n}\n.divE7-consumpDash {\n  grid-area: 3 / 5 / 4 / 3;\n}\n.div5-consumpDash {\n  grid-area: 4 / 1 / 6 / 7;\n}\n.div6-consumpDash {\n  grid-area: 6 / 1 / 8 / 7;\n}\n.div8-consumpDash {\n  grid-area: 7 / 1 / 9 / 4;\n}\n.div9-consumpDash {\n  grid-area: 8 / 1 / 10 / 7;\n}\n.div11-consumpDash {\n  grid-area: 10 / 1 / 12 / 7;\n\n}\n.div12-consumpDash { grid-area: 12 / 1 / 14 / 4; }\n.div13-consumpDash { grid-area: 12 / 4 / 14 / 7; }\n.div14-consumpDash { grid-area: 14 / 1 / 16 / 7; }\n\n.download-invoice {\n  display: flex;\n  justify-content: center;\n}\n\n.icon-download {\n  cursor: pointer;\n}\n\n.sort-arrow {\n  margin-left: 5px;\n  cursor: pointer;\n  color: rgb(116, 116, 116);\n}\n\n.titles {\n  display: flex;\n  justify-content: center;\n}\n\n.title {\n  color: black;\n}\n\n.title-consumpCost{\n  font-weight: 600;\n}\n\n.donuts-container {\n  display: flex;\n  justify-content: space-around; \n  align-items: flex-start;\n}\n\n.cont-donuts {\n  flex: 1;\n  margin: 10px;\n  text-align: center;\n  max-width: 250px;\n  max-height: 260px;\n}\n\n/* menu reportes */\n/* DashConsumption.css */\n.dropdown-toggle-reports:hover{\n  color: #4e6278;\n  transition: color 0.3s ease;\n}\n\n.dropdown-menu-reports {\n  padding: 10px;\n  min-width: 230px;\n  border-radius: 8px;\n  box-shadow: 0px 4px 12px rgba(0,0,0,0.1);\n}\n\n.dropdown-menu-reports li button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  color: #73879c;\n  padding-bottom: 0px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.dropdown-menu-reports li:hover {\n  background-color: #f2f2f2;\n  border-radius: 6px;\n}\n\n.dropdown-menu-reports button {\n  all: unset;\n  width: 100%;\n  text-align: left;\n}\n\n/* ChartTypeSelector */\n.chart-type-selector {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n  gap: 2px;\n}\n\n.chart-type-button {\n  cursor: pointer;\n  padding: 4px 8px;\n  background: none;\n  color: #4e6278;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.chart-type-button:hover {\n  background-color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
